(() => {
  const metalKey = (value) => {
    const v = String(value || '').toLowerCase();
    if (v.includes('goud') || v.includes('gold')) return 'goud';
    if (v.includes('zilver') || v.includes('silver')) return 'zilver';
    return null;
  };

  const init = (sec) => {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const jsonEl = sec.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const form = sec.querySelector('form[data-product-form]');
    const idInput = sec.querySelector('[data-variant-id]');
    const picker = sec.querySelector('[data-variant-picker]');
    const fieldsets = picker ? Array.from(picker.querySelectorAll('[data-option]')) : [];
    const atc = sec.querySelector('[data-atc]');
    const atcLabel = sec.querySelector('[data-atc-label]');
    const atcLabelHtml = atcLabel ? atcLabel.innerHTML : '';
    let incomplete = false;
    let current = null;

    if (window.Nova && Nova.trackView) Nova.trackView(data.handle);

    const hints = {};
    String(data.hints || '')
      .split(/\r?\n/)
      .forEach((line) => {
        const i = line.indexOf(':');
        if (i > 0) hints[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
      });

    const selected = () =>
      fieldsets.map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });

    const findVariant = (sel) => data.variants.find((v) => v.options.every((o, i) => sel[i] === o));

    const setText = (selector, text) => {
      sec.querySelectorAll(selector).forEach((el) => (el.textContent = text));
    };

    const updateAvailability = (sel) => {
      fieldsets.forEach((fs, idx) => {
        fs.querySelectorAll('input').forEach((input) => {
          if (input.disabled) return;
          const withValue = data.variants.filter((v) => v.options[idx] === input.value);
          const combos = withValue.filter((v) => v.options.every((o, j) => j === idx || sel[j] === null || sel[j] === o));
          /* Bestaat de combinatie niet, dan springen de andere keuzes mee; kijk dan naar alle varianten met deze waarde */
          const ok = (combos.length ? combos : withValue).some((v) => v.available);
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    };

    const updateShipLine = (variant) => {
      const el = sec.querySelector('[data-ship-line]');
      if (!el || !variant) return;
      const total = parseInt(el.dataset.cartTotal || '0', 10);
      const threshold = parseInt(el.dataset.threshold || '0', 10);
      if (!threshold) return;
      if (total >= threshold) el.textContent = el.dataset.textFree;
      else if (total + variant.price >= threshold) el.textContent = el.dataset.textNow;
      else el.textContent = el.dataset.textFrom;
    };
    document.addEventListener('nova:cart', (e) => {
      const el = sec.querySelector('[data-ship-line]');
      if (el && e.detail && e.detail.cart) {
        el.dataset.cartTotal = e.detail.cart.total_price;
        updateShipLine(current);
      }
    });

    const update = ({ syncMetal = true, pushUrl = true } = {}) => {
      const sel = selected();
      fieldsets.forEach((fs, idx) => {
        const valueEl = fs.querySelector('[data-option-value]');
        const hintEl = fs.querySelector('[data-option-hint]');
        const needs = fs.querySelector('[data-needs-choice]');
        if (sel[idx] !== null) {
          if (valueEl) {
            const checked = fs.querySelector('input:checked');
            const label = checked ? fs.querySelector(`label[for="${checked.id}"]`) : null;
            valueEl.textContent = label ? label.textContent.trim() : sel[idx];
          }
          if (needs) needs.hidden = true;
          if (hintEl) hintEl.textContent = hints[String(sel[idx]).toLowerCase()] || '';
        } else if (hintEl) {
          hintEl.textContent = '';
        }
      });
      updateAvailability(sel);

      incomplete = sel.some((v) => v === null);
      const variant = incomplete ? null : findVariant(sel);
      current = variant;

      const buyAvailable = sec.querySelector('[data-buy-available]');
      const buySoldout = sec.querySelector('[data-buy-soldout]');
      const stockLine = sec.querySelector('[data-stock-line]');
      const stockText = sec.querySelector('[data-stock-text]');
      const delivery = sec.querySelector('[data-delivery-line]');

      if (incomplete) {
        if (buyAvailable) buyAvailable.hidden = false;
        if (buySoldout) buySoldout.hidden = true;
        return;
      }

      if (!variant) {
        if (stockText) stockText.textContent = Nova.strings.unavailable;
        if (stockLine) stockLine.className = 'stock-line is-out';
        if (delivery) delivery.hidden = true;
        if (atc) atc.disabled = true;
        return;
      }

      if (atc) atc.disabled = false;
      if (idInput) idInput.value = variant.id;
      setText('[data-price]', variant.priceText);
      setText('[data-atc-price]', variant.priceText);
      setText('[data-sticky-price]', variant.priceText);
      setText('[data-klarna]', variant.klarnaText);
      setText('[data-sticky-sub]', `${variant.title} · ${variant.priceText}`);
      const notifyBody = sec.querySelector('[data-notify-body]');
      if (notifyBody) notifyBody.value = `${data.title} (${variant.title})`;

      if (buyAvailable) buyAvailable.hidden = !variant.available;
      if (buySoldout) buySoldout.hidden = variant.available;
      if (stockLine && stockText) {
        let cls = 'stock-line';
        let text = stockText.dataset.inStock;
        if (!variant.available) {
          cls += ' is-out';
          text = Nova.strings.soldOut;
        } else if (variant.qty !== null && variant.qty > 0 && variant.qty <= data.lowStock) {
          cls += ' is-low';
          text = (stockText.dataset.lowTpl || '').replace('{n}', variant.qty);
        }
        stockLine.className = cls;
        if (text) stockText.textContent = text;
      }
      if (delivery) delivery.hidden = !variant.available;

      if (data.metalIndex > 0) {
        const key = metalKey(variant.options[data.metalIndex - 1]);
        if (key) {
          if (syncMetal) Nova.setMetal(key);
          const sw = sec.querySelector('[data-sticky-swatch]');
          if (sw) sw.style.background = key === 'goud' ? 'var(--gold)' : 'var(--silver)';
        }
      }

      if (pushUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      updateShipLine(variant);
      showVariantMedia(variant);
      updateGallery();
    };

    /* Bestaat de combinatie niet, kies dan de best passende variant met de aangeklikte waarde */
    const matchCombination = (input) => {
      const idx = fieldsets.findIndex((fs) => fs.contains(input));
      if (idx < 0) return;
      const sel = selected();
      if (sel.some((v) => v === null) || findVariant(sel)) return;
      const score = (v) => v.options.reduce((n, o, i) => n + (i !== idx && sel[i] === o ? 1 : 0), 0) + (v.available ? 0.5 : 0);
      const best = data.variants
        .filter((v) => v.options[idx] === input.value)
        .sort((x, y) => score(y) - score(x))[0];
      if (!best) return;
      best.options.forEach((value, i) => {
        if (i === idx || !fieldsets[i]) return;
        const match = Array.from(fieldsets[i].querySelectorAll('input')).find((el) => el.value === value);
        if (match) match.checked = true;
      });
    };

    if (picker) {
      picker.addEventListener('change', (e) => {
        if (e.target && e.target.matches('input')) matchCombination(e.target);
        update();
      });
    }

    document.addEventListener('nova:metal', (e) => {
      if (!picker || data.metalIndex < 1) return;
      const fs = fieldsets[data.metalIndex - 1];
      if (!fs) return;
      const input = fs.querySelector(`input[data-metal-key="${e.detail.metal}"]:not(:disabled)`);
      if (input && !input.checked) {
        input.checked = true;
        update({ syncMetal: false });
      }
    });

    /* Toevoegen aan winkelmand */
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (incomplete) {
          fieldsets.forEach((fs) => {
            if (!fs.querySelector('input:checked')) {
              const needs = fs.querySelector('[data-needs-choice]');
              if (needs) needs.hidden = false;
            }
          });
          const first = fieldsets.find((fs) => !fs.querySelector('input:checked'));
          if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (!current || !current.available) return;
        atc.classList.add('is-loading');
        atc.disabled = true;
        try {
          await Nova.addToCart([{ id: current.id, quantity: 1 }]);
          if (atcLabel) {
            atcLabel.textContent = Nova.strings.added;
            setTimeout(() => {
              atcLabel.innerHTML = atcLabelHtml;
              if (current) setText('[data-atc-price]', current.priceText);
            }, 2000);
          }
        } catch (err) {}
        atc.classList.remove('is-loading');
        atc.disabled = false;
      });
    }

    /* Galerij */
    const track = sec.querySelector('[data-gallery-track]');
    const count = sec.querySelector('[data-gallery-count]');
    const visibleItems = () => Array.from(sec.querySelectorAll('[data-gallery-item]')).filter((el) => el.offsetParent !== null);
    const markFirst = () => {
      const all = Array.from(sec.querySelectorAll('[data-gallery-item]'));
      const first = all.find((el) => getComputedStyle(el).display !== 'none');
      all.forEach((el) => el.classList.toggle('is-first', el === first));
    };
    const updateGallery = () => {
      markFirst();
      if (!track || !count) return;
      const items = visibleItems();
      if (!items.length) return;
      const w = items[0].clientWidth || 1;
      const i = Math.min(items.length, Math.round(track.scrollLeft / w) + 1);
      count.textContent = `${i} / ${items.length}`;
    };
    /* Foto van de gekozen variant vooraan zetten */
    const originalOrder = track ? Array.from(track.querySelectorAll('[data-gallery-item]')) : [];
    const showVariantMedia = (variant) => {
      if (!track || !originalOrder.length) return;
      const pos = variant && variant.media;
      const item = pos ? originalOrder.find((el) => el.dataset.mediaPosition === String(pos)) : null;
      const first = track.firstElementChild;
      if (item ? first === item && item === originalOrder[0] : first === originalOrder[0]) return;
      /* Snap even uit, anders springt de carrousel mee met de foto die verplaatst wordt */
      track.style.scrollSnapType = 'none';
      originalOrder.forEach((el) => track.appendChild(el));
      if (item) track.insertBefore(item, track.firstElementChild);
      track.scrollLeft = 0;
      markFirst();
      requestAnimationFrame(() => {
        track.style.scrollSnapType = '';
        track.scrollLeft = 0;
      });
    };
    markFirst();
    document.addEventListener('nova:metal', markFirst);
    if (track) {
      track.addEventListener('scroll', () => window.requestAnimationFrame(updateGallery), { passive: true });
      const step = (d) => {
        const items = visibleItems();
        if (!items.length) return;
        track.scrollBy({ left: d * items[0].clientWidth, behavior: 'smooth' });
      };
      const prev = sec.querySelector('[data-gallery-prev]');
      const next = sec.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', () => step(-1));
      if (next) next.addEventListener('click', () => step(1));
      document.addEventListener('nova:metal', () => {
        track.scrollTo({ left: 0 });
        setTimeout(updateGallery, 50);
      });
    }

    /* Lightbox */
    const box = sec.querySelector('[data-lightbox]');
    if (box && typeof box.showModal === 'function') {
      const img = box.querySelector('[data-lightbox-img]');
      const label = box.querySelector('[data-lightbox-count]');
      let list = [];
      let index = 0;
      const show = () => {
        const src = list[index];
        if (!src) return;
        img.src = src;
        img.alt = data.title;
        label.textContent = `${index + 1} / ${list.length} · ${data.title}`;
      };
      sec.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-zoom]');
        if (!btn) return;
        const items = visibleItems();
        list = items.map((el) => el.querySelector('img[data-zoom-src]')).filter(Boolean).map((i) => i.dataset.zoomSrc);
        const own = btn.closest('[data-gallery-item]').querySelector('img[data-zoom-src]');
        index = Math.max(0, list.indexOf(own ? own.dataset.zoomSrc : ''));
        show();
        box.showModal();
      });
      box.querySelector('[data-lightbox-close]').addEventListener('click', () => box.close());
      box.querySelector('[data-lightbox-prev]').addEventListener('click', () => {
        index = (index - 1 + list.length) % list.length;
        show();
      });
      box.querySelector('[data-lightbox-next]').addEventListener('click', () => {
        index = (index + 1) % list.length;
        show();
      });
      box.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') box.querySelector('[data-lightbox-prev]').click();
        if (e.key === 'ArrowRight') box.querySelector('[data-lightbox-next]').click();
      });
    }

    /* Vaste koopbalk */
    const sticky = sec.querySelector('[data-sticky-buy]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        const show = past && (!current || current.available || incomplete);
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        const btn = sticky.querySelector('[data-sticky-add]');
        if (btn) btn.tabIndex = show ? 0 : -1;
      });
      io.observe(atc);
      sticky.querySelector('[data-sticky-add]').addEventListener('click', () => {
        if (incomplete) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          form.requestSubmit();
          return;
        }
        form.requestSubmit();
      });
    }

    /* Startwaarde: volg het gekozen metaal van de bezoeker als er geen variant in de URL staat */
    const params = new URLSearchParams(window.location.search);
    if (!params.has('variant') && data.metalIndex > 0 && fieldsets[data.metalIndex - 1]) {
      const fs = fieldsets[data.metalIndex - 1];
      const input = fs.querySelector(`input[data-metal-key="${Nova.getMetal()}"]:not(:disabled)`);
      if (input) input.checked = true;
      update({ syncMetal: false, pushUrl: false });
    } else {
      update({ pushUrl: false });
    }
  };

  const boot = () => document.querySelectorAll('[data-product-section]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
